import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=4f06bb18&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"
import style0 from "./Footer.vue?vue&type=style&index=0&id=4f06bb18&prod&scoped=true&lang=css"
import style1 from "./Footer.vue?vue&type=style&index=1&id=4f06bb18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f06bb18",
  null
  
)

export default component.exports